export default __webpack_public_path__ + "media/images/logo/media/the_bridge-66442941a71667ef75038e33e218ff28.png";